import React from "react";
import PropTypes from "prop-types";
import { TOAST_TIMEOUT, VM_NOT_FOUND_MSG } from "constants/constants";
import "components/Toasts/Toasts.css";
import { CrossIcon, SuccessIcon } from "constants/icons";

//Shows toast of two types : 1. Success 2. Error
function Toasts({ open, closeToast, title, message, error }) {
  let parentClassName = `toasts__wrapper ${
    error ? "error-toast" : "success-toast"
  }`;

  //Appends class to show modal on screen.
  if (open) {
    parentClassName += " show-toast";
    //Hide toast after a certain time.
    setTimeout(() => {
      closeToast();
    }, TOAST_TIMEOUT);
  }

  return (
    <div className={parentClassName}>
      <div className="toasts__wrapper--icon">
        {error ? (
          <i>
            <CrossIcon />
          </i>
        ) : (
          <i>
            <SuccessIcon />
          </i>
        )}
      </div>
      {
        <div className="toasts__text-wrapper">
          <div className="text-wrapper__title">{title}</div>
          <div className="text-wrapper__message">{message}</div>
        </div>
      }
    </div>
  );
}

Toasts.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  error: PropTypes.bool,
  closeToast: PropTypes.func.isRequired,
};

export default Toasts;
